export const INTERNAL_USER_EMAIL_DOMAIN = '@envirosuite.';
